import { FC, useCallback, useState } from "react"
import { businessDeleteApi } from "src/domain/api/business/businessDeleteApi"
import { Business } from "src/domain/entities/business"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	business: Business
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const BusinessDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	business,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleBusinessDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await businessDeleteApi({ id: business.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [business, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Business: ${business.name.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleBusinessDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
